<template>
<div class="SmallProcedures">
</div>
</template>

<script>
export default {
    name: 'SmallProcedures',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SmallProcedures {
}
</style>
